import { Coordinates } from "../types";

/**
 * Direction vector for movement
 */
export type DirectionEnum = "up" | "down" | "left" | "right";

export class Direction {
  public value: DirectionEnum;
  constructor(value: DirectionEnum) {
    this.value = value;
  }
  toVector() {
    switch (this.value) {
      case "up":
        return { dx: 0, dy: -1 };
      case "down":
        return { dx: 0, dy: 1 };
      case "left":
        return { dx: -1, dy: 0 };
      case "right":
        return { dx: 1, dy: 0 };
    }
  }

  /**
   * Helper: Convert vector to direction
   */
  static fromVector(dx: number, dy: number): Direction | null {
    if (dx === 0 && dy === -1) return new Direction("up");
    if (dx === 0 && dy === 1) return new Direction("down");
    if (dx === -1 && dy === 0) return new Direction("left");
    if (dx === 1 && dy === 0) return new Direction("right");
    return null;
  }

  /**
   * Helper: Get position in a direction
   */
  protected toCoordinates(col: number, row: number): Coordinates {
    const { dx, dy } = this.toVector();
    return { col: col + dx, row: row + dy };
  }
}

export const allDirections: Direction[] = [
  new Direction("up"),
  new Direction("down"),
  new Direction("left"),
  new Direction("right"),
];
